import { HistoryLogDto } from "./HistoryLogDto";
import { FileDto } from "../common/interfaces/FileDto";
import { NotaryPreviewDto } from "./NotaryPreviewDto";
import { SettlementPreviewDto } from "./SettlementPreviewDto";
import { PageDto } from "../common/interfaces/PageDto";
import { OwnerDto } from "./OwnerDto";

export enum Issuer {
  Notary = "notary",
  Settlement = "settlement",
}

type WithdrawnAuthorizationBase = {
  withdrawnAuthorizationId?: number;
  registrationNumber?: number;
  issueDate?: Date;
  authorizer?: string;
  authorized?: string;
  description?: string;
  authorizations?: AuthorizationForWithdrawal[];
} & OwnerDto;

export type AuthorizationForWithdrawal = {
  authorizationId?: number;
  notary?: NotaryPreviewDto;
  registrationNumber?: number;
  issueDate?: Date;
  settlement?: SettlementPreviewDto;
  issuer?: Issuer;
};

export type WithdrawnAuthorizationInputDto = {
  userId: number;
  fileId?: number;
  correctionReason?: string;
  version?: string;
} & WithdrawnAuthorizationBase;

export type WithdrawnAuthorizationPreviewDto = {
  notary: NotaryPreviewDto;
  file: FileDto;
  historyLogs: HistoryLogDto[];
  createDate: Date;
} & WithdrawnAuthorizationBase;

export type WithdrawnAuthorizationSearchDto = {
  notaryId?: number;
  registrationNumber?: number;
  issueDate?: Date;
  keywords?: string;
  authorizer: boolean;
  authorized: boolean;
  description: boolean;
} & PageDto;

export type WithdrawnAuthorizationSearchResultDto = {
  withdrawnAuthorizationId: number;
  registrationNumber: number;
  issueDate: Date;
  notary: NotaryPreviewDto;
  authorizer: string;
  authorized: string;
  description: string;
} & OwnerDto;

export type WithdrawnAuthorizationHistoryPreviewDto = {
  correctionReason?: string;
} & WithdrawnAuthorizationPreviewDto;
